 function formatAllOptionGroups() {
    const dlGroups = document.querySelectorAll('dl');

    dlGroups.forEach(dl => {
      const seen = new Set();
      const options = dl.querySelectorAll('.product-option');

      options.forEach(option => {
        const dt = option.querySelector('dt');
        if (!dt) return;

        const text = dt.textContent.trim();
        const match = text.match(/^(\d+)\s*-\s*(.*)/);

        if (match) {
          const number = match[1];
          const label = match[2];

          if (seen.has(number)) {
            dt.textContent = label;
            dt.style.marginLeft = '20px';
            dt.style.fontWeight = 'normal';
          } else {
            seen.add(number);
            dt.innerHTML = `<strong>${text}</strong>`;
            dt.style.marginLeft = '0';
          }
        }
      });
    });
  }

  // Throttle utility
  function throttle(fn, limit) {
    let lastCall = 0;
    return function () {
      const now = Date.now();
      if (now - lastCall >= limit) {
        lastCall = now;
        fn();
      }
    };
  }

  const throttledFormat = throttle(formatAllOptionGroups, 200); // 200ms throttle

  // Initial run
  formatAllOptionGroups();

  // MutationObserver
  const observer = new MutationObserver(() => {
    throttledFormat();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: false,
  });

  const cartDrawer = document.querySelector('div#shopify-section-wi-cartdrawer');
  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }